import { Controller } from "@hotwired/stimulus";
import { resolveTodo } from "../../todo_list/todo_resolver";
import { refreshTodoSidePanel } from "../../todo_list/refresh_todo_side_panel";

export default class extends Controller {
  connect() {
    this._subscribeToTodoStatusChannel();
  }

  _subscribeToTodoStatusChannel() {
    App.cable.subscriptions.create(
      { channel: "TodoChannel", stream_name: "status" },
      {
        received: (data) => {
          if (data.processed) {
            resolveTodo(data.id);
          } else {
            refreshTodoSidePanel(data.id);
          }
        },
      }
    );
  }
}
